import GooglePublisherTag from 'components/shared/GooglePublisherTag/GooglePublisherTag';
import SharedBannerAd from 'components/shared/BannerAd/BannerAd';

export default class BannerAd {
  static setup() {
    if(window.kmklabs === undefined) return
    var gpt = window.kmklabs.gpt;

    if(gpt.top_banner_ad_unit && gpt.top_banner_ad_size)
      BannerAd.setTopBanner(gpt);

    if(gpt.pause_ad_unit && gpt.pause_ad_size)
      GooglePublisherTag.setPauseAd(gpt.pause_ad_unit, gpt.pause_ad_size);

    if(gpt.overlay_ad_unit && gpt.overlay_ad_size)
      GooglePublisherTag.setOverlayAd(gpt.overlay_ad_unit, gpt.overlay_ad_size);
  }

  static setTopBanner(gpt) {
    let interval = window.__adsConfig && window.__adsConfig.top_banner_refresh_interval || 0;

    SharedBannerAd.setBannerAd(
      "top_banner_container",
      "top_banner",
      gpt.top_banner_ad_unit,
      gpt.top_banner_ad_size,
      GooglePublisherTag.displayTopBannerAd,
      () => {
        GooglePublisherTag.refreshAdSlot(gpt.top_banner, 'top_banner', false, interval);
      }
    );
  };
}
